import React, { useEffect, useState } from 'react';
import { useWidget } from '../useWidget';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import Alert from 'components/Dialogs/Alert';
import { staticRanges } from 'components/DateRangePicker/components/staticRanges';
import { Select } from 'antd';

const DateFilter = ({ handleFilters }) => {
  const { default_filter, disableDateFilter = false, filters, widget_key } = useWidget();
  const { dates } = useWidgetDate('global');

  const [selectedPeriodKey, setSelectedPeriodKey] = useState(
    default_filter?.date_range_key || null
  );

  useEffect(() => {
    setSelectedPeriodKey(filters?.date_range_key || null);
  }, [filters.date_range_key]);

  if (disableDateFilter) {
    return null;
  }

  return (
    <div className='grid gap-2 items-center w-full'>
      <Select
        className='w-full'
        placeholder='Select a period'
        value={selectedPeriodKey}
        onChange={(key) => {
          setSelectedPeriodKey(key);
          const preset = staticRanges.find((p) => p.key === key);
          if (preset) {
            const [from, to] = preset.value;
            handleFilters('selected_period', key);
            handleFilters('date_from', from.format('YYYY-MM-DD'));
            handleFilters('date_to', to.format('YYYY-MM-DD'));
            handleFilters('date_range_key', key);
          }
        }}
        allowClear={true}
        onClear={() => {
          {
            setSelectedPeriodKey(default_filter?.date_range_key || null);
            handleFilters('selected_period', default_filter?.date_range_key);
            handleFilters({ ...dates });
            handleFilters('date_from', default_filter?.date_from);
            handleFilters('date_to', default_filter?.date_to);
            handleFilters('date_range_key', default_filter?.date_range_key);
          }
        }}
        options={staticRanges.map(({ key, label }) => ({ value: key, label }))}
      />
      <Alert
        type='warning'
        showIcon
        description={
          <span className='text-xs'>The widget will always use this selected period.</span>
        }
      />
    </div>
  );
};

export default DateFilter;
